import React from 'react'

function Nav() {
  return (
    <div className='nav'>
      <a id="stick" href='/'>Local</a>
      <a href='/global'>Global</a>
    </div>
  )
}

export default Nav